import type { ProviderOptionConfirmation } from "@amoreg/contracts";
import { create } from "zustand";

/**
 * A model option waiting on the person's say-so (the server marks such
 * choices with a `confirmation`, e.g. Ultrafast's usage warning).
 *
 * The traits menu closes as soon as an option is picked, taking its content
 * with it, so the question lives here and one dialog in the composer
 * (`OptionConfirmationDialog`) asks it. Nothing changes until it is accepted.
 */
interface PendingOptionConfirmation {
  readonly confirmation: ProviderOptionConfirmation;
  readonly apply: () => void;
}

interface OptionConfirmationState {
  readonly pending: PendingOptionConfirmation | null;
  readonly request: (confirmation: ProviderOptionConfirmation, apply: () => void) => void;
  readonly accept: () => void;
  readonly dismiss: () => void;
}

export const useOptionConfirmationStore = create<OptionConfirmationState>((set, get) => ({
  pending: null,
  request: (confirmation, apply) => set({ pending: { confirmation, apply } }),
  accept: () => {
    const pending = get().pending;
    set({ pending: null });
    pending?.apply();
  },
  dismiss: () => set({ pending: null }),
}));
